import { render, staticRenderFns } from "./wizard-progress.vue?vue&type=template&id=6d2d1f04&"
import script from "./wizard-progress.vue?vue&type=script&lang=js&"
export * from "./wizard-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports